import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'

import API from '../api'

@autobind
class SchoolFollow extends Component {
  constructor (props) {
    super(props)
    this.state = {loading: false}
  }

  toggleFollow () {
    this.setState({loading: true})
    const action = !this.props.isFollowing ? 'follow' : 'unfollow'
    return API.post(`/v3/me/schools_follows/${action}`, { school_id: this.props.schoolId })
      .then(() => {
        this.setState({loading: false})
        this.props.onFollow(!this.props.isFollowing)
      })
  }

  render () {
    return (
      <button className='SchoolFollow__btn btn btn-primary' onClick={this.toggleFollow} disabled={this.state.loading}>{this.props.isFollowing ? 'Following' : <span>Follow<b> school</b></span>}</button>
    )
  }
}

export default SchoolFollow

SchoolFollow.propTypes = {
  user: PropTypes.object,
  schoolId: PropTypes.string,
  onFollow: PropTypes.func,
  isFollowing: PropTypes.bool
}



// WEBPACK FOOTER //
// ./components/search/SchoolFollow.js